
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as UtilizationModels from '../../models/utilization/utilization';
import { UtilizationSearchModel } from '../../models/utilization/utilizationSearch';
import { EnvironmentService } from '../../../app/services/environment.service';

@Injectable({
  providedIn: 'root'
})

export class UtilizationService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public get(Search: UtilizationSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();
    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<UtilizationModels.UtilizationListModel>(`${this.environmentService.getApiURL()}/utilisation/list`, Search, options);
  }

  public getReport(Search: UtilizationSearchModel) {

    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/utilisation/report/filtered`, Search, options);

  }


}
